<template>
  <div class="col-12 m-0 p-0 post-media">
    <div v-if="medias.length > 0" class="mt-1 mb-3" >
      <div v-for="media in medias" :key="media.id">
        <a v-if="checkPDF( media.media )" class="text-dark" :href="`${ api_url }/post/${ media.media }`" target="_blank"><i class="fa fa-file-pdf"></i> Baixar PDF</a>
        <img v-else class="media w-100" v-lazy="`${ api_url }/post/${ media.media }`" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    medias: {
      required: false
    }
  },
  data () {
    return {
      api_url: process.env.VUE_APP_ROOT_BASE,
    }
  },
  methods: {
    checkPDF: function ( data ) {
      let v = data.split('.')
      return v[ v.length - 1 ].toUpperCase() === 'PDF'
    }
  }
}
</script>
